document.addEventListener('DOMContentLoaded', function() {
    let scaleFactor = 1;
    const realCardHeightMm = 53.98;

    window.selectDevice = function(choice) {
        const deviceSelection = document.getElementById('deviceSelection');
        const calibration = document.getElementById('calibration');
        const ringMeasurement = document.getElementById('ringMeasurement');

        if (choice === 'yes') {
            scaleFactor = 1;
            deviceSelection.classList.add('hidden');
            ringMeasurement.classList.remove('hidden');
            adjustRingSize();
        } else {
            deviceSelection.classList.add('hidden');
            calibration.classList.remove('hidden');
        }
    };

    const cardSlider = document.getElementById('cardSlider');
    const creditCard = document.getElementById('creditCard');

    if (cardSlider) {
        cardSlider.addEventListener('input', function() {
            const height = this.value;
            creditCard.style.height = height + 'px';
            creditCard.style.width = (height / 0.63) + 'px';
        });
    }

    window.confirmCalibration = function() {
        const calibration = document.getElementById('calibration');
        const ringMeasurement = document.getElementById('ringMeasurement');

        const adjustedHeightPx = parseFloat(cardSlider.value);
        const pixelsPerMm = adjustedHeightPx / realCardHeightMm;
        scaleFactor = pixelsPerMm / 3.78;

        calibration.classList.add('hidden');
        ringMeasurement.classList.remove('hidden');

        adjustRingSize();
    };

    const ringSlider = document.getElementById('ringSlider');
    const ring = document.getElementById('ring');

    function adjustRingSize() {
        const diameter = ringSlider.value;
        const scaledDiameter = diameter * scaleFactor * 2;
        ring.style.width = scaledDiameter + 'px';
        ring.style.height = scaledDiameter + 'px';
        ring.textContent = diameter;
        ring.parentElement.style.width = scaledDiameter + 'px';
        ring.parentElement.style.height = scaledDiameter + 'px';
    }

    if (ringSlider) {
        ringSlider.addEventListener('input', adjustRingSize);
    }

    window.startMeasurement = function() {
        alert('Mesure commencée ! Veuillez ajuster le curseur pour correspondre à votre bague.');
    };
});